import useScrollReveal from '../useScrollReveal';
import { sectionStyles, getCardClass, isCardTransparent, getAnimation, hexToRgba } from '../utils';
import SectionHeader from './SectionHeader';
import SectionDivider from './SectionDivider';

export default function LocationsSection({ block = {}, primaryColor, secondaryColor, enableAnimations, cardStyle }) {
    const { config = {}, content = {} } = block;
    const s = sectionStyles(config, primaryColor, secondaryColor);
    const [ref, visible] = useScrollReveal(0.15, !enableAnimations);

    // Use items from block content (manual data)
    const establishments = (content.items || []).filter(item => item.name);
    if (establishments.length === 0) return null;

    const title = content.title || 'Nuestras sedes';
    const subtitle = content.subtitle || 'Encuentranos en las siguientes ubicaciones';
    const cols = config.columns || 3;
    const gridCls = cols === 2 ? 'md:grid-cols-2' : 'md:grid-cols-2 lg:grid-cols-3';
    const card = getCardClass(cardStyle, s.dark);
    const tp = isCardTransparent(cardStyle, s.dark);
    const anim = getAnimation(config, visible);

    return (
        <section className={`${s.padClass} relative`} style={s.bgStyle.background ? s.bgStyle : { backgroundColor: s.bg || '#f9fafb', ...s.bgStyle }}>
            <SectionDivider type={config.divider_top} color="transparent" position="top"  config={config}/>
            <div ref={ref} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${anim}`}>
                <SectionHeader tag={content.tag || 'Ubicaciones'} title={title} subtitle={subtitle} config={config} s={s} />
                <div className={`grid grid-cols-1 ${gridCls} gap-6`}>
                    {establishments.map((est, i) => (
                        <div key={i}
                            className={`group ${card} p-6 transition-all duration-500 hover:-translate-y-1 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
                            style={{ transitionDelay: visible ? `${150 + i * 100}ms` : '0ms' }}>
                            <div className="flex items-start gap-4">
                                <div className="flex-shrink-0 w-14 h-14 rounded-xl flex items-center justify-center transition-transform duration-300 group-hover:scale-110"
                                    style={{ backgroundColor: hexToRgba(s.accent, 0.07) }}>
                                    <svg className="w-7 h-7" style={{ color: s.accent }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                                    </svg>
                                </div>
                                <div className="min-w-0">
                                    <h3 className="font-bold text-lg" style={{ color: s.text }}>{est.name}</h3>
                                    {est.address && <p className="text-sm mt-1 leading-relaxed" style={{ color: s.textSub }}>{est.address}</p>}
                                    {est.latitude && est.longitude && (
                                        <a href={`https://www.google.com/maps?q=${est.latitude},${est.longitude}`} target="_blank" rel="noopener noreferrer"
                                            className="inline-flex items-center gap-1.5 text-sm mt-3 font-medium hover:underline transition-colors" style={{ color: s.accent }}>
                                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/></svg>
                                            {content.map_link_text || 'Ver en Google Maps'}
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <SectionDivider type={config.divider_bottom} color={config.divider_bottom_color || '#ffffff'} position="bottom"  config={config}/>
        </section>
    );
}
